import * as types from '../../../lib/actionTypes.es6';

export var getOrgIppConfigsRequest = function(organizationGuid) {
  return { type: types.GET_ORG_IPP_CONFIGS_REQUEST, payload: organizationGuid };
};
export var getOrgIppConfigsSuccess = function(payload) {
  return { type: types.GET_ORG_IPP_CONFIGS_SUCCESS, payload: payload };
};
export var getOrgIppConfigsFailure = function(error) {
  return { type: types.GET_ORG_IPP_CONFIGS_FAILURE, payload: error };
};

export var createOrgIppConfigRequest = function(payload) {
  return { type: types.CREATE_ORG_IPP_CONFIG_REQUEST, payload: payload };
};
export var createOrgIppConfigSuccess = function(payload) {
  return { type: types.CREATE_ORG_IPP_CONFIG_SUCCESS, payload: payload };
};
export var createOrgIppConfigFailure = function(error) {
  return { type: types.CREATE_ORG_IPP_CONFIG_FAILURE, payload: error };
};
export var resetCreateOrgIppConfigSuccess = function() {
  return { type: types.RESET_CREATE_ORG_IPP_CONFIG_SUCCESS };
};
export var resetCreateOrgIppConfigError = function() {
  return { type: types.RESET_CREATE_ORG_IPP_CONFIG_ERROR };
};

export var updateOrgIppConfigRequest = function(payload) {
  return { type: types.UPDATE_ORG_IPP_CONFIG_REQUEST, payload: payload };
};
export var updateOrgIppConfigSuccess = function(payload) {
  return { type: types.UPDATE_ORG_IPP_CONFIG_SUCCESS, payload: payload };
};
export var updateOrgIppConfigFailure = function(error) {
  return { type: types.UPDATE_ORG_IPP_CONFIG_FAILURE, payload: error };
};
export var resetUpdateOrgIppConfigSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_IPP_CONFIG_SUCCESS };
};
export var resetUpdateOrgIppConfigError = function() {
  return { type: types.RESET_UPDATE_ORG_IPP_CONFIG_ERROR };
};

export var deleteOrgIppConfigRequest = function(payload) {
  return { type: types.DELETE_ORG_IPP_CONFIG_REQUEST, payload: payload };
};
export var deleteOrgIppConfigSuccess = function(payload) {
  return { type: types.DELETE_ORG_IPP_CONFIG_SUCCESS, payload: payload };
};
export var deleteOrgIppConfigFailure = function(error) {
  return { type: types.DELETE_ORG_IPP_CONFIG_FAILURE, payload: error };
};
export var resetDeleteOrgIppConfigSuccess = function() {
  return { type: types.RESET_DELETE_ORG_IPP_CONFIG_SUCCESS };
};
export var resetDeleteOrgIppConfigError = function() {
  return { type: types.RESET_DELETE_ORG_IPP_CONFIG_ERROR };
};
